export const EXTERNAL_PARTNER_IDS = {
  NORWEGIAN: "9F716345-D78C-468A-A8BA-BB07528F6813",
} as const;
